import React, { useEffect, useState } from 'react';

const AgendaTabNav = ({ activeTab, availableTabs, clickTabBar }) => {
	const [tabs, setTabs] = useState([]);

	// /**
	//    * @description    Click handlier that sends the clicked tab to the parent component
	//    * @param {event} e - click event
	// */
	const handleClick = (e) => {
		if (!e.currentTarget.classList.contains('is-active')) {
			clickTabBar(e.currentTarget.dataset.label);
		}
	};

	/**
	 * @description    Hook that loads the tabs from available tabs
	 */
	useEffect(() => {
		setTabs(
			Object.keys(availableTabs).map((tab, index) => (
				<button
					key={index}
					onClick={(e) => handleClick(e)}
					data-label={tab}
					className={`
                        tab-nav__link
                        btn
                        ${tab !== 'all' ? 'show-on-mobile' : ''}
                        ${activeTab === tab ? 'is-active' : ''}
                     `}
				>
					{tab === 'all_events' ? (
						//Longer text on desktop than on mobile
						<>
							{availableTabs[tab].split(' ', 1)}
							<span className="hide_mobile">&nbsp;{availableTabs[tab].split(' ').slice(1, availableTabs[tab].split(' ').length).join(' ')}</span>
						</>
					) : (
						availableTabs[tab]
					)}
				</button>
			))
		);
	}, [activeTab]);

	return <div className="tab-nav tab-nav--react-filter">{tabs}</div>;
};

export default AgendaTabNav;
